module.exports = __webpack_public_path__ + "img/logo.89b019a0.png";